export const navText = {
  JP: {
    home: "ホーム",
    tours: "ツアー",
    itinerary: "旅程",
    oceanGuide: "海況ガイド",
    droneMap: "ドローンマップ",
    gallery: "ギャラリー",
    aboutMe: "私について",
    faq: "よくある質問",
    blog: "ブログ",
    contact: "お問い合わせ",
    followMe: "FOLLOW ME",
    lineCta: "LINEで相談・予約する",
    instaCta: "Instagramで相談・予約する",
  },

  EN: {
    home: "Home",
    tours: "Tours",
    itinerary: "Itinerary",
    oceanGuide: "Ocean Guide",
    droneMap: "Drone Map",
    gallery: "Gallery",
    aboutMe: "About Me",
    faq: "FAQ",
    blog: "Blog",
    contact: "Contact",
    followMe: "FOLLOW ME",
    lineCta: "Chat / Book on LINE",
    instaCta: "Chat / Book on Instagram",
  },

  中文: {
    home: "首页",
    tours: "行程",
    itinerary: "旅行计划",
    oceanGuide: "海况指南",
    droneMap: "无人机地图",
    gallery: "相册",
    aboutMe: "关于我",
    faq: "常见问题",
    blog: "博客",
    contact: "联系我们",
    followMe: "关注我",
    lineCta: "通过LINE咨询 / 预约",
    instaCta: "通过Instagram咨询 / 预约",
  },

  한국어: {
    home: "홈",
    tours: "투어",
    itinerary: "일정",
    oceanGuide: "바다 가이드",
    droneMap: "드론 맵",
    gallery: "갤러리",
    aboutMe: "소개",
    faq: "FAQ",
    blog: "블로그",
    contact: "문의하기",
    followMe: "FOLLOW ME",
    lineCta: "LINE으로 상담 / 예약하기",
    instaCta: "Instagram으로 상담 / 예약하기",
  },
};
